module.exports = __webpack_public_path__ + "6c4f2a8cf6a2c442d48d9c3db87f06f8.pdf";